import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmPin = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-pin",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-pin",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      clipRule: "evenodd",
      d: "m6.5 4c1.5-1.5 3.5-2.3 5.5-2.3s4 .8 5.5 2.3c1.4 1.4 2.3 3.4 2.3 5.5 0 3.5-2 6.8-4.1 9.2-1 1.2-2.1 2.2-2.9 2.8-.3.3-.6.5-.8.6-.2-.2-.5-.4-.8-.6-.8-.7-1.8-1.6-2.9-2.8-2-2.5-4-5.7-4-9.3 0-2 .8-4 2.2-5.4zm5.5 20h-8.6v-1.7h6.2c-.7-.7-1.6-1.5-2.5-2.5-2.2-2.5-4.5-6.1-4.5-10.3 0-2.5 1-4.9 2.8-6.7 1.7-1.8 4.1-2.8 6.6-2.8s4.9 1 6.7 2.8 2.8 4.2 2.8 6.7c0 4.2-2.3 7.8-4.5 10.3-.9 1-1.8 1.9-2.5 2.5h6.2v1.7zm0-17.1c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6c0-1.5-1.2-2.6-2.6-2.6zm-4.3 2.5c0-2.4 1.9-4.3 4.3-4.3s4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3-4.3-1.9-4.3-4.3z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
});
IconLlmPin.displayName = 'IconLlmPin';

export { IconLlmPin };
//# sourceMappingURL=llm-pin.js.map
